import { useTranslation } from "react-i18next";
import RmItem from "./rmItem";

import { IRm } from "interface/book";
import { priceFormat } from "util/commAction";
import i18n from "locales/i18n";
import { useRef, useState } from "react";
import { IOption } from "interface";
import "../book.scss";
import "./step1.scss";

type ISelect = {
  list: any[];
  type: "modal" | "web";
  handleSelectPrd(item: any): void;
};

const Select = ({ list, handleSelectPrd }: ISelect) => {
  const langCd = i18n.language;

  const defaultValue = { rmCnt: 0, totalPrice: 0 };

  const [item, setItem] = useState<any>(defaultValue);

  const optionRef = useRef<HTMLUListElement>(null);
  // const selectRef = useRef<HTMLDivElement>(null);

  // //OUTSIDE CLICK
  // const outSideClick = (e: any) => {
  //   if (
  //     selectRef.current &&
  //     !selectRef.current.contains(e.target) &&
  //     optionRef.current
  //   ) {
  //     optionRef.current.className = "";
  //     optionRef.current.hidden = true;
  //     selectRef.current.className = "select" + " ";
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("click", outSideClick);

  //   return () => {
  //     document.removeEventListener("click", outSideClick);
  //   };
  // }, []);

  return (
    <div className="op-select">
      <button
        onClick={(e) => {
          if (optionRef.current) {
            const styles = optionRef.current?.className;
            styles.includes("hidden")
              ? optionRef.current.classList.remove("hidden")
              : optionRef.current.classList.add("hidden");
          }
        }}
      >
        {item.rmCnt}
      </button>
      <ul className="option hidden" ref={optionRef}>
        {[defaultValue, ...list].map((item, index) => {
          return (
            <li
              className="flex cursor-pointer hover:bg-blue-300-15 px-2 py-1"
              key={index}
              data-value={item[langCd as keyof IOption]}
              onClick={(e) => {
                setItem(item);
                if (optionRef.current) {
                  optionRef.current.classList.add("hidden");
                }

                handleSelectPrd(item);
              }}
            >
              {item.rmCnt}&nbsp;&nbsp;&nbsp;(&nbsp;
              {priceFormat(item.totalPrice)}&nbsp;)
            </li>
          );
        })}
      </ul>
    </div>
  );
};

type IProps = {
  rmList: IRm[] | null | any;
  isLoading: boolean;
};

export default function BookStep1({ rmList, isLoading }: IProps) {
  const { t } = useTranslation();

  return (
    <div className="rm-list">
      <h3 className="sub">{t("bck_ttl_bk_gen")}</h3>

      {isLoading && (
        <div className="w-full h-full center">
          <h4 className="font-font-R">Loading ....</h4>
        </div>
      )}

      <div
        className={!rmList || (rmList && rmList?.length === 0) ? "no-list" : ""}
        data-txt={t("bk_no_data_info_bk")}
      >
        {rmList &&
          rmList.map((rmInf: IRm) => {
            return <RmItem key={rmInf.rmPdNo} rmInf={rmInf} />;
          })}
      </div>
    </div>
  );
}
